class FilterDrawer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.summary = this.querySelector("summary");
    this.details = this.querySelector("details");
    this.content = this.querySelector("[data-content]");

    this.summary.addEventListener("click", (e) => {
      e.preventDefault();

      this.details.open ? this.close() : this.open();
    });

    this.addEventListener("click", (e) => {
      if (!e.target.closest("[data-close]")) return;

      this.close();
    });

    this.toggleDrawer = () => {
      if (this._showDrawer) {
        this.content.style.height = null;

        if (this.details.open) {
          window.openFullDimmer(this);
          window.lockScroll(this);
        }
      } else {
        window.closeFullDimmer(this);
        window.unlockScroll(this);

        if (this.details.open) {
          this._openHeight = `${this.content.scrollHeight}px`;
        }
      }
    };

    window.addEventListener("resize", this.toggleDrawer);

    this.handleDocumentClick = (e) => {
      // Check that element has not been removed from DOM
      if (!document.body.contains(e.target)) return;

      if (this.details.open && !this.contains(e.target)) {
        this.close();
      }
    };

    this.handleKeyUp = (e) => {
      if (this.details.open && e.code.toUpperCase() === "ESCAPE") {
        this.close();
      }
    };

    document.addEventListener("keyup", this.handleKeyUp);
    document.addEventListener("click", this.handleDocumentClick);
  }

  disconnectedCallback() {
    window.removeEventListener("resize", this.toggleDrawer);
    document.removeEventListener("keyup", this.handleKeyUp);
    document.removeEventListener("click", this.handleDocumentClick);
  }

  open() {
    if (this.details.open) return;
    this.removeEventListener("transitionend", this.handleTransitionEnd);

    this.details.open = true;
    if (this.content) {
      this.handleTransitionEnd = () => {
        this.removeEventListener("transitionend", this.handleTransitionEnd);
        this.content.style.overflow = "visible";
      };

      this.addEventListener("transitionend", this.handleTransitionEnd);

      window.requestAnimationFrame(() => {
        if (this._showDrawer) {
          window.openFullDimmer(this);
          window.lockScroll(this);
        } else {
          this._openHeight = `${this.content.scrollHeight}px`;
        }
        this.classList.add("open");
      });
    }
  }

  close() {
    if (!this.details.open) return;
    if (this.content) {
      this.removeEventListener("transitionend", this.handleTransitionEnd);

      this.handleTransitionEnd = () => {
        this.removeEventListener("transitionend", this.handleTransitionEnd);
        this.details.open = false;
      };

      this.addEventListener("transitionend", this.handleTransitionEnd);

      this._openHeight = 0;
      this.classList.remove("open");
      window.unlockScroll(this);
      window.closeFullDimmer(this);
    } else {
      this.details.open = false;
    }
  }

  set _openHeight(height) {
    this.style.setProperty("--open-height", height);
  }

  get _showDrawer() {
    return window.matchMedia(this._mediaQuery).matches;
  }

  get _mediaQuery() {
    return this.getAttribute("show-drawer-when") || "all";
  }
}

if (!customElements.get("filter-drawer")) {
  customElements.define("filter-drawer", FilterDrawer);
}
